export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOADED = "USER_LOADED";
export const USER_QUICK_MENU = "USER_QUICK_MENU";
